import React from 'react';
import PropTypes from 'prop-types';

import styles from './checkbox.module.scss';

const Row = ({ children }) => <div className={styles.row}>{children}</div>;

Row.propTypes = {
  /** The contents of the row, <Checkbox /> or <RadioButton /> */
  children: PropTypes.any,
};

Row.defaultProps = {
  children: undefined,
};

Row.displayName = 'Checkbox.Row';
export default Row;
